module.exports = __webpack_public_path__ + "img/menu_send.d75dcaa5.png";